//brand level kambi options
export default {
  '8': {
    'homeUrl': '/',
    'googleAnalyticsWebPropertyID': 'UA-40318756-1',
  },
  '0': {
    'homeUrl': '/',
    'googleAnalyticsWebPropertyID': 'UA-40318756-1',
  },
  '1': {
  },
  '58': {
    'homeUrl': '/apuestas-online/',
  },
  '31': {
    'homeUrl': '/scommesse-sportive/',
    'disableCashIn': true
  },
  '75': {
    'homeUrl': '/odds/',
  },
  '81': {
    'homeUrl': '/'
  },
};
